import { render } from "./CampDetail.vue?vue&type=template&id=c3fb02cc&scoped=true"
import script from "./CampDetail.vue?vue&type=script&lang=js"
export * from "./CampDetail.vue?vue&type=script&lang=js"

import "./CampDetail.vue?vue&type=style&index=0&id=c3fb02cc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c3fb02cc"

export default script